import { useNavigate } from 'react-router-dom';
import { useGetItem } from './useGetItem';
import { useUpdateItem } from './useUpdateItem';
import { IInputPropertiesBase } from '@2r/frontend-component-library';
import { useQueryClient } from '@tanstack/react-query';

export function useModul<TData>(baseApiPath: string, keyName: string, $new?: boolean) {
    const query = useGetItem<TData>(baseApiPath, keyName);
    const api = useUpdateItem<TData>(baseApiPath);

    const navigateTo = useNavigate();
    const queryClient = useQueryClient();

    const data = query.data;

    function leaveFrame(mode: number, data?: TData): void {
        switch (mode) {
            case 1: // Speichern
                if ($new === true) {
                    api.create(data!);
                } else {
                    api.save(data!);

                    queryClient.removeQueries({ queryKey: [query.primaryKey] });
                }

                break;

            case 4: // L�schen
                break;

            case 2: // Abbruch
            case 3: // Zur�ck
            default:
                break;
        }

        navigateTo("../List");
    }

    function setValue<TValue>(data: TData, name: keyof TData & string, v: TValue) {
        data[name] = v as unknown as (TData & {})[keyof TData & string];

        return true;
    }

    function bind<TValue>(name: keyof TData & string): IInputPropertiesBase {
        if (data === undefined || data === null) {
            return {
                Name: name,
                key: name,
                value: undefined,
                onChange: (v: TValue) => true,
            };
        }
        else {
            return {
                Name: name,
                key: name,
                value: data[name],
                onChange: (v: TValue) => setValue<TValue>(data, name, v),
            }
        }
    }

    return {
        data: data,
        bind: bind,
        isLoading: query.isLoading,
        primaryKey: query.primaryKey,
        onLeave: leaveFrame,
    }
}